// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3YiL9","disabled":"FileBtn_disabled__2X5WZ","warn":"FileBtn_warn__2-hi2","fade":"FileBtn_fade__360Ty"};